import { render, staticRenderFns } from "./RepairLog.vue?vue&type=template&id=36e96a62&scoped=true"
import script from "./RepairLog.vue?vue&type=script&lang=js"
export * from "./RepairLog.vue?vue&type=script&lang=js"
import style0 from "./RepairLog.vue?vue&type=style&index=0&id=36e96a62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e96a62",
  null
  
)

export default component.exports